import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';


import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';

import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { CommonService } from '../../../_common/_service/user.service';
import { AddcardComponent } from '../../popup/add-card/add-card.component';
import { ConfirmDialogComponent } from '../../popup/confirm-dialog/confirm-dialog.component';
import { ConfirmNGNDialogComponent } from '../../popup/confirm-ngn-dialog/confirm-ngn-dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-GiftVoucher',
  templateUrl: './GiftVoucher.component.html',
  styleUrls: ['./GiftVoucher.component.scss']
})
export class GiftVoucherComponent implements OnInit {
  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  FlatChargesByCountry: any;
  cardnoList: any;
  show: any;
  AddMoneyForm: FormGroup;
  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  countryIsdcode: any;
  OptionList1: any;
  ActualAmount: any;
  loadingspinner: boolean = false;
  NetworkList: any;
  payoutCurrency: any;
  VoucherList: any;
  optionbtn: any;
  constructor(private ngxService: NgxUiLoaderService, private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService,
    private tokenService: AuthenticationService, private _service: CommonService
  ) {
    this.AddMoneyForm = this.fb.group({
     
      //PaymentModeCode: ["CDC"],
      amount: [null, [Validators.required]],
      email: [null, [Validators.required]],
      accountServiceId: [null, [Validators.required]]
    
    })
  }



  ngOnInit(): void {
    ;
    this.serviceCode = this.route.snapshot.queryParams.serviceCode;

    this.token = this.tokenStorageService.getToken();

    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();
      //this.getaddoptionList();
      this.getVoucherList();
      this.show = 2;
    }
    else {
      this._service.callMethodOfSecondComponent();
    }
    
  }

  Back() {

    this.router.navigate(['/Go-on']);
  }


  get f() { return this.AddMoneyForm.controls; }

  changeMethod(val: any) {
    this.amt = val.Amount;
    debugger;
  }
  
  
  string1: any;
  AddmobileMoneyForm(post: any) {
    debugger;
    this.submitted = true;
    if (this.optionbtn == null || this.optionbtn == undefined) {

      this.toastr.error("Choose Payment Option", 'Error');

    }
    else {

      this.loadingspinner = true;

      post.email = this.currentUser.email;
      post.amount = this.amt;
      
      post.productIds = null;
      post.flag= this.optionbtn;
      debugger;

      this.authService.addMoneyRequestupi(post).subscribe((response: { apiStatus: boolean; apiMessage: any; apiData: any; transactionStatus: any }) => {

        this.loadingspinner = false;

        if (response.apiStatus == true) {

          this.AddMoneyForm.reset();
          this.submitted = false;
          this.amt = 0;

          window.location.href = response.apiData.Url;

        }
        else {
          this.toastr.error(response.apiMessage, 'Error');
        }
      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
   
  }

  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any) {

    //this.submitted = true;
    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode};
    this.authService.getServiceCommissionList(Amountrequested, SelectedrblOptionCode, SelectedNetworkCode, this.currentUser.serviceid).subscribe((response:
      { apiData: any; apiStatus: any; apiMessage: string | undefined; }) => {
      debugger;
      if (response.apiStatus == true) {

        this.commissionList = response.apiData;
        this.amt = Amountrequested;
        this.commissionFee = this.commissionList.totalCommission;
        this.commissionTotal = this.commissionList.totalAmount;
        this.ActualAmount = this.commissionList.actualAmount;
        this.payoutCurrency = this.commissionList.payoutCurrency;

      } else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }


  
  


  getVoucherList() {

    debugger
    this.authService.getVoucherList().subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; }) => {
      debugger
      
      if (response.apiStatus == true) {
        this.VoucherList = response.apiData;
        console.log(response);
        // this.toastr.successToastr(response.Message, AppConstant.success);
      }
      else if (response.apiStatus == false) { //    "apiMessage": "user account is disable",
        this.toastr.warning(response.apiMessage, 'Warning');
        this._service.callMethodOfSecondComponent();
      }
      else {
        this.toastr.error(response.apiMessage, 'Error');
      }

    }, (err: any) => {
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {

        this.toastr.error(err.error, 'Error');
      }
    }
    );
  }

  changeMethodpayment(event: any) {


    this.optionbtn = event.value;
  }








}
